module.exports = __webpack_public_path__ + "officialStatic/img/dcjgLogo.878f8d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/dcjgLogo.png
// module id = Xkgd
// module chunks = 0